module.exports = __webpack_public_path__ + "src/assets/sounds/plastic_2_sound.mp3";